import { useGuid } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import React, { Fragment, memo, useMemo, useRef } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { RcHoverTrigger } from '../../hooks/popper';
import { AxisType, useAxisMark } from '../../hooks/region';
import { RcPopover } from '../../units/popover-wrapper';
export var SliderMark = memo(function (props) {
  var value = props.value,
      format = props.format,
      _props$tooltip = props.tooltip,
      tooltip = _props$tooltip === void 0 ? false : _props$tooltip,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'center' : _props$placement,
      markListClassName = props.markListClassName;
  var id = useGuid();
  var ids = useMemo(function () {
    return [id];
  }, []);

  var _useAxisMark = useAxisMark(AxisType.HORIZONTAL, value),
      selected = _useAxisMark.selected,
      offset = _useAxisMark.offset,
      precisionValue = _useAxisMark.precisionValue;

  var elemRef = useRef(null);
  var cls = usePrefixCls('slider-mark', {
    invalid: invalid,
    selected: selected
  });
  var popCls = usePrefixCls('slider-mark-pop');
  var popWrapperCls = classnames(usePrefixCls('slider-mark-pop-wrapper'), markListClassName);
  return React.createElement(Fragment, null, React.createElement(RcHoverTrigger, {
    ref: elemRef,
    className: cls,
    triggerId: id,
    style: {
      left: "".concat(offset, "px")
    }
  }), React.createElement(RcPopover, {
    arrow: false,
    className: popCls,
    zIndex: 0,
    refType: "trigger",
    refId: id,
    triggerIds: ids,
    wrapperClassName: popWrapperCls,
    placement: placement === 'left' ? 'bottom-start' : placement === 'right' ? 'bottom-end' : 'bottom',
    show: true,
    disableAnimation: true,
    preventOverflow: false,
    scaleAnimation: false,
    getPopper: function getPopper() {
      if (tooltip) {
        return tooltip;
      }

      return format ? format(precisionValue) : precisionValue;
    }
  }));
});